import React from 'react';
import './PageTitleContact.scss';

const PageTitleContact = ({title, description}) => {
    return (
        <div className='page-title-contact'>
            <h1>{title}</h1>
            <p>{description}</p>
        </div>
    );
};

export default PageTitleContact; 